import React, {Component} from 'react';
import {Trans, withTranslation} from 'react-i18next';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import MiniMap from 'components/Shared/MiniMap';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import 'index.css';
import 'components/Account/Localisation.scss';

import Context from 'utils/Context';

class Localisation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadOk: [],
      uploadKo: [],
      showUpload: false,
    };
    this.handleUploaded = this.handleUploaded.bind(this);
  }
  handleUploaded(res) {
    let uploadOk = this.state.uploadOk;
    let uploadKo = this.state.uploadKo;
    this.setState({
      uploadOk: [...uploadOk, ...res.success],
      uploadKo: [...uploadKo, ...res.errors],
    });
  }
  render() {
    const {geoloc, appState, modele, methods} = this.context;
    const {t} = this.props;

    if (!appState.user) return null;

    return (
      <Paper>
        <Container disableGutters>
          <Grid container>
            <Grid item xs={12}>
              <DialogContent className="geoloc-info">
                <Typography variant="h6">{t('ma-zone-geographique')}</Typography>
                {!geoloc && (
                  <>
                    <p>
                      {t(
                        'nous-navons-pas-pu-determiner-votre-position-avec-suffisamment-de-precision-voici-quelques-conseils-pour-une-meilleure-geolocalisation',
                      )}
                    </p>
                    <p>- {t('veillez-a-bien-autoriser-la-geolocalisation-de-votre-navigateur-pour-ce-site')}</p>
                    <p>- {t('veillez-a-activer-la-geolocalisation-dans-vos-parametres-systeme')}</p>
                    <p>
                      -{' '}
                      <Trans i18nKey="la-geolocalisation-marche-souvent-mieux-depuis">
                        {' '}
                        <strong> </strong>{' '}
                      </Trans>
                    </p>
                  </>
                )}
                {!!geoloc && (
                  <p>
                    {t(
                      'vous-pouvez-ameliorer-votre-geolocalisation-en-vous-connectant-a-cette-page-depuis-un-appareil-mobile-qui-partage-votre-connection-internet-box-internet-ou-partage-de-connection-mobile-une-fois-connecte-cliquez-sur-mettre-a-jour-ma-geolocalisation',
                    )}
                  </p>
                )}
              </DialogContent>
              {!!geoloc && (
                <MiniMap
                  lat={geoloc.latitude}
                  lng={geoloc.longitude}
                  radius={geoloc.accuracy}
                  cinemas={modele.cinemas}
                  zoom={6}
                />
              )}
              <DialogContent className="geoloc-info">
                <Grid container className="localisation-legende" spacing={3}>
                  <Grid item xs={4}>
                    <div className="localisation-legende-marker">
                      <img
                        alt="my position marker"
                        src="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png"
                      />
                    </div>
                    {t('ma-position')}
                  </Grid>
                  <Grid item xs={4}>
                    <div className="localisation-legende-marker">
                      <img
                        alt="accessible cinema marker"
                        src="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png"
                      />
                    </div>
                    {t('les-cinemas-auxquels-j-ai-acces')}
                  </Grid>
                  <Grid item xs={4}>
                    <div className="localisation-legende-marker">
                      <img
                        alt="not accessible cinema marker"
                        src="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png"
                      />
                    </div>
                    {t('les-cinemas-hors-de-ma-zone')}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                {!appState.updatingGeoloc && (
                  <Button color="primary" variant="contained" onClick={methods.refreshGeoloc}>
                    {t('mettre-a-jour-ma-geolocalisation')}
                  </Button>
                )}
                {appState.updatingGeoloc && (
                  <Button color="default" disabled variant="contained">
                    <CircularProgress size="20px" /> &nbsp; {t('mettre-a-jour-ma-geolocalisation')}
                  </Button>
                )}
              </DialogActions>
            </Grid>
          </Grid>
        </Container>
      </Paper>
    );
  }
}

Localisation.contextType = Context;

export default withTranslation()(Localisation);
